import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss() {
    if (!this.element.isConnected) return

    this.element.remove()
  }
}
